import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private snack = inject(MatSnackBar);

  success(message: string, duration = 4000): void {
    this.snack.open(message, 'Close', { duration, panelClass: ['ns-success'], horizontalPosition: 'end', verticalPosition: 'top' });
  }

  error(message: string, duration = 6000): void {
    this.snack.open(message, 'Close', { duration, panelClass: ['ns-error'], horizontalPosition: 'end', verticalPosition: 'top' });
  }

  warning(message: string, duration = 5000): void {
    this.snack.open(message, 'Close', { duration, panelClass: ['ns-warning'], horizontalPosition: 'end', verticalPosition: 'top' });
  }
}